import React from "react";
import { Datepicker } from "@mobiscroll/react";

export const CreateDateFilter = ({ value, onChange, disabled, className }) => {
  return (
    <Datepicker
      select="range"
      returnFormat="iso8601"
      controls={["date"]}
      value={value ?? []}
      placeholder="Select range"
      onChange={(range) => onChange(range.value)}
      themeVariant="light"
      className={className}
      inputProps={{
        readOnly: true,
        className: "dates-range-light-input",
        "data-testid": "create-date-filter-input",
      }}
      disabled={disabled}
    />
  );
};
